import * as React from "react";
import ModelViewer from "component/ModelViewer";

function EntryCard({ entryNumber, name, image, title, owner, graph, preview3d }) {
  return (
    <article className="flex flex-col justify-center m-6 p-6 text-center bg-white">
      <div className="flex gap-4 justify-center p-2 text-center text-white bg-pink-600 rounded-[136px]">
        <div className="my-auto text-sm">{entryNumber}</div>
        <div className="text-lg font-semibold leading-7">{name}</div>
      </div>
      <img src={image} alt={title} className="mt-6 w-[200px] mx-auto" />
      <h2 className="mt-6 text-2xl text-black">{title}</h2>
      <div className="self-center mt-2 text-xl text-indigo-400">
        Owned by {owner}
      </div>
      <div className="mx-auto">
        <ModelViewer src={preview3d} height={"249px"} />
      </div>
      <img src={graph} className="-mt-10" alt="" />
    </article>
  );
}

function EntryMobile(props) {
  return <EntryCard {...props} />;
}
export default EntryMobile;
